import {
    SET_TICKETS,
    SET_TICKETS_CURRENT_PAGE,
    SET_TICKETS_TOTAL_PAGES,
    SET_TICKETS_TOTAL_DOCS,
    SET_SINGLE_TICKET,
    SET_TICKETS_STATUS
} from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
    tickets: [],
    ticket: null,
    ticketsStatus: "WaitingForResponse",
    ticketsCurrentPage: 0,
    ticketsTotalPages: 0,
    ticketsTotalDocs: 0,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SET_TICKETS: {
            return {
                ...state,
                tickets: action.payload,
            };
        }
        case SET_TICKETS_CURRENT_PAGE: {
            return {
                ...state,
                ticketsCurrentPage: action.payload,
            };
        }
        case SET_TICKETS_TOTAL_PAGES: {
            return {
                ...state,
                ticketsTotalPages: action.payload,
            };
        }
        case SET_TICKETS_TOTAL_DOCS: {
            return {
                ...state,
                ticketsTotalDocs: action.payload,
            };
        }
        case SET_SINGLE_TICKET: {
            return {
                ...state,
                ticket: action.payload,
            };
        }
        case SET_TICKETS_STATUS: {
            return {
                ...state,
                ticketsStatus: action.payload,
            };
        }
        default:
            return state;
    }
};